import { reportRecipientService } from '_services';
import ACTIONS_REPORT_RECIPIENT from '_constants/reportRecipient.constants';
import alertActions from './alert.actions';

export const receiveReportRecipients = (reportRecipients) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < reportRecipients.length; i++) {
    byIdObjectToDispatch[reportRecipients[i].reportRecipientID] = reportRecipients[i];
  }

  return {
    type: ACTIONS_REPORT_RECIPIENT.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

export const deleteReportRecipient = (reportRecipientID) => ({
  type: ACTIONS_REPORT_RECIPIENT.DELETE,
  byId: { [reportRecipientID]: null }
});

const searchReportRecipients = (props) => async (dispatch) => {
  try {
    const resp = await reportRecipientService.search(props);
    if (resp?.reportRecipients) {
      dispatch(receiveReportRecipients(resp.reportRecipients));
      return resp.reportRecipients;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error('Error searching report definitions.'));
  }
  return null;
};

const getReportRecipient = (reportRecipientID) => async (dispatch) => {
  try {
    const resp = await reportRecipientService.getById(reportRecipientID);
    if (resp?.reportRecipient) {
      dispatch(receiveReportRecipients([ resp.reportRecipient ]));
      return resp.reportRecipient;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error(`Error retrieving report definition: ${reportRecipientID}.`));
  }
  return null;
};

const addReportRecipient = (reportRecipient) => async (dispatch) => {
  try {
    const resp = await reportRecipientService.create(reportRecipient);
    if (resp?.reportRecipients) {
      dispatch(receiveReportRecipients([ resp.reportRecipients ]));
      return resp.reportRecipients;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error('Error creating report definition.'));
  }
  return null;
};

const updReportRecipient = (reportRecipient) => async (dispatch) => {
  try {
    const resp = await reportRecipientService.update(reportRecipient);
    if (resp?.reportRecipient) {
      dispatch(receiveReportRecipients([ resp.reportRecipient ]));
      return resp.reportRecipient;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error('Error updating report definition.'));
  }
  return null;
};

const delReportRecipient = (reportRecipientID) => async (dispatch) => {
  try {
    const resp = await reportRecipientService.delete(reportRecipientID);
    if (resp?.reportRecipient) {
      dispatch(deleteReportRecipient(reportRecipientID));
      return resp.reportRecipient;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error(`Error removing report definition: ${reportRecipientID}.`));
  }
  return null;
};

const reportRecipientActions = {
  searchReportRecipients,
  getReportRecipient,
  addReportRecipient,
  updReportRecipient,
  delReportRecipient
};

export default reportRecipientActions;
